module.exports = __webpack_public_path__ + "static/media/gmr.1705da0e.svg";